const fixedHeader = document.querySelector('.fixed-header');
if (window.scrollY > 0) {
  fixedHeader.classList.add('filled');
}
function fixed() {
  const e = window.scrollY || document.documentElement.scrollTop;
  if (e > 0) {
    fixedHeader.classList.add('filled');
  } else {
    fixedHeader.classList.remove('filled');
  }
}
window.addEventListener('scroll', fixed);
const topbar = document.querySelector('.topbar');
const drawer = document.querySelector('.shopify-section.menu-drawer');
const mainContent = document.getElementById('MainContent');
const searchModal = document.querySelector('.search-modal.modal__content.gradient');
if (window.innerWidth <= 767) {
  if (drawer) {
    drawer.style.top = `${topbar.offsetHeight + 102}px`;
  }
  if (!document.body.classList.contains('template--index')) {
    mainContent.style.paddingTop = `${topbar.offsetHeight + 48}px`;
  }
} else {
  if (!document.body.classList.contains('template--index')) {
    mainContent.style.paddingTop = `${topbar.offsetHeight + 48}px`;
  }
}

if (searchModal) {
  searchModal.style.transition = 'top 250ms ease, background-color 250ms ease';

  const applySearchModalTop = () => {
    const scrolled = (window.scrollY || document.documentElement.scrollTop) >= 40;
    const isCollectionsPage = window.location.pathname.includes('/collections');
    const isHomepage = window.location.pathname === '/' || document.body.classList.contains('template--index');
    const header = document.querySelector('.header');
   
 
    const inputValue = document.querySelector('.aa-Input')?.value || '';
    const isTypingActive =
      window.innerWidth < 1024 &&
      (searchModal.classList.contains('yk-search-modal-active') || inputValue.trim().length > 0);

    let nextTop = '';


    if (isCollectionsPage) {
      if (isTypingActive) {
       
        nextTop = `${topbar.offsetHeight + header.offsetHeight}px`;
       
      } else if (window.innerWidth > 1024) {
      
        nextTop = '0px';
      } else if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
        nextTop = 
        `${topbar.offsetHeight + header.offsetHeight}px`
      } else {
       
        nextTop = scrolled
          ? `${topbar.offsetHeight + header.offsetHeight}px`
          : `${topbar.offsetHeight + header.offsetHeight + 42}px`;
      }
    } else if (isHomepage) {
      if (isTypingActive) {
        nextTop = `${topbar.offsetHeight + header.offsetHeight}px`;
       
      } else if (window.innerWidth > 1024) {
        nextTop = '0px';
      } else if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
        nextTop = 
        `${topbar.offsetHeight + header.offsetHeight}px`
      } else {
        nextTop = scrolled
          ? `${topbar.offsetHeight + header.offsetHeight}px`
          : `${topbar.offsetHeight + header.offsetHeight + 52}px`;
      }
    } else {
      if (isTypingActive) {
        nextTop = `${topbar.offsetHeight + header.offsetHeight}px`;
       
      } else if (window.innerWidth > 1024) {
        nextTop = '0px';
      }  else {
        nextTop = `${topbar.offsetHeight + header.offsetHeight}px`;
      }
    }


    searchModal.style.top = nextTop;

    if (window.innerWidth < 1024) {
      const panel = document.querySelector('.aa-Panel');
      if (panel) {
        const rect = searchModal.getBoundingClientRect();
        panel.style.top = `${rect.bottom + window.scrollY - 7}px`;
      }
    }
  };

  applySearchModalTop();
  window.addEventListener('scroll', applySearchModalTop);
  window.addEventListener('resize', applySearchModalTop);
  document.addEventListener(
    'input',
    (event) => {
      const input = event.target && event.target.closest && event.target.closest('.aa-Input');
      if (!input) return;
      applySearchModalTop();
    },
    true
  );
}
